export default {
  text_1_1: 'バックアップは、これまでになく簡単かつ安全に。',
  text_1_2: 'プライバシー要件に応える拡張オプション。',
  text_2_1: '耐久性・携帯性に優れ、曲げに強い設計。',
  text_2_2: 'CC EAL6+ によるセキュリティ',
  text_2_3: 'チップ—どこへでも持ち運べます。',
  text_2_4: '耐曲げ・耐磁・帯電防止。',
  text_2_5: '最大 50 万回のカードスワイプに対応。',
  text_3_1:
    'TokenPocket によるエンパワーで、KeyPal Card 使用時に完璧なユーザー体験を提供。',
  text_4_1: 'PIN コード対応でセキュリティを強化',
  text_4_2:
    'PIN を 10 回連続で誤入力すると、カードは自動消去されます。',
  text_4_3: 'バックアップだけでなく、署名にも対応',
  text_4_4:
    'このカードはバックアップ用途にとどまらず、トランザクション署名の重要なコンポーネントとしても機能します。',
  text_4_5: 'NFC のワンタッチバックアップで、簡単かつ安全。',
  text_4_6: '電磁界による高速な双方向暗号化を有効化し、迅速でシンプルなバックアップを実現。',
  text_5_1: 'さあ始めましょう — あなたの',
  text_6_1: 'ウォレット',
  text_6_2:
    'シームレスに統合し、すべての KeyPal Card がつながる比類なきウォレット体験を。',
  text_6_3: 'バックアップ',
  text_6_4:
    '誤ったバックアップによる資産損失リスクを取り除き、手間なく安全にバックアップ。',
  text_6_5: '署名',
  text_6_6:
    'KeyPal Card で多様なウォレット活用を解放し、あらゆる署名を容易にします。',
};
